import React,{Component} from "react";
import { connect } from "react-redux";
import { Alert, Modal, ModalHeader,ModalBody } from 'reactstrap';
import Actions from "../../../Actions";
import Form from "./Form";
import Tile from "../Layout/Tile";


class Edit extends Component{
    constructor(props){
        super(props);
        this.modalRef = false;
    }

    componentDidUpdate(){
        const { locationStore: { alert: { edit } } } = this.props;
        if(edit && this.modalRef ) this.modalRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
    }

    render = () => {
        const { locationStore: { alert: { edit } }, editLocation, modalStore: { edit: { modal, data, data: { id } }}, toggleModal } = this.props;
        return (
            <div>
                <Modal size="lg" isOpen={modal} toggle={() => toggleModal("locations","edit")}>
                    <ModalHeader toggle={() => toggleModal("locations","edit")}>Edit Location</ModalHeader>
                    <ModalBody style={{backgroundColor:"#f2f2f2"}}>
                        <div ref={(ref) => this.modalRef = ref}>    
                            <Tile xs="11" style={{marginTop:15,paddingTop:15,backgroundColor:"#fff"}} className="shadow-sm rounded mx-auto">
                                {edit !== false &&
                                    <Alert color={edit.location}>
                                        {edit.message}
                                    </Alert>
                                }
                                <Form data={data} id={id} persist={editLocation} />
                            </Tile>
                        </div>
                    </ModalBody>
                </Modal>
            </div>                            
        );
    }
}

const mapStateToProps = (state) => ({
    locationStore: state.locationStore,
    modalStore: state.modalStore.locations,
});

const { locations, modals } = Actions;


export default connect(mapStateToProps, { ...locations, ...modals })(Edit);


// WEBPACK FOOTER //
// ./src/Components/App/Locations/Edit.js